module.exports = "<div id=\"chartdiv\" [style.width.%]=\"100\" [style.height.px]=\"500\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chart/chart.component.html
// module id = ./src/app/components/chart/chart.component.html
// module chunks = main